<div class="card">
  <div class="card-body workspace-members-container">
    <!-- Left list: Organization Users (adding members) — managers/admin only -->
    <div class="list-section" *ngIf="canManageMembers">
      <h2>{{ 'title.available_users' | translate | uppercase }}</h2>
      <ts-paginated-search-header
        class="mb-2"
        [searchValue]="facade.organizationUsersSearchTerm$ | async"
        (searchChanged)="onOrganizationSearchTermChange($event)"
        [previousTokens]="facade.organizationUsersPreviousTokens$ | async"
        [lastItem]="facade.organizationUsersNextToken$ | async"
        [length]="facade.organizationUsersTotalCount$ | async"
        [pageSize]="facade.organizationUsersPageSize$ | async"
        [disabled]="facade.organizationUsersLoading$ | async"
        (pageChange)="handleOrganizationUserPageEvent($event)"
        [counting]="facade.organizationUsersCounting$ | async"
        data-cy="organization-users-search"
      ></ts-paginated-search-header>
      <ts-user-list
        [items]="organizationUsers$ | async"
        [loading]="organizationUsersLoading$ | async"
        [noUsers]="(organizationUsers$ | async)?.length === 0 && (organizationUsersLoading$ | async) === false"
        [columns]="displayColumns"
        [canEdit]="false"
        (membershipToggle)="onOrganizationUserToggle($event)"
        data-cy="organization-users-list"
      ></ts-user-list>
    </div>

    <!-- Right list: Workspace Members -->
    <div class="list-section">
      <h2>{{ 'title.current_users' | translate | uppercase }}</h2>
      <ts-paginated-search-header
        class="mb-2"
        [searchValue]="facade.membersSearchTerm$ | async"
        (searchChanged)="onMembersSearchTermChange($event)"
        [previousTokens]="facade.membersPreviousTokens$ | async"
        [lastItem]="facade.membersNextToken$ | async"
        [length]="facade.membersTotalCount$ | async"
        [pageSize]="facade.membersPageSize$ | async"
        [disabled]="facade.membersLoading$ | async"
        (pageChange)="handleMemberPageEvent($event)"
        [counting]="facade.membersCounting$ | async"
        data-cy="workspace-members-search"
      ></ts-paginated-search-header>
      <ts-user-list
        [items]="workspaceMembers$ | async"
        [loading]="membersLoading$ | async"
        [noUsers]="(workspaceMembers$ | async)?.length === 0 && (membersLoading$ | async) === false"
        [columns]="memberColumns"
        [canEdit]="false"
        (membershipToggle)="onMemberToggle($event)"
        data-cy="workspace-members-list"
      ></ts-user-list>
    </div>
  </div>
</div>
